import React from 'react';
import { Platform, View } from 'react-native';
import AnimatedContent from './AnimatedContent/AnimatedContent';

export const WebCategoryCard = ({ children, cardIndex = 0 }) => {
  if (Platform.OS !== 'web') {
    return children;
  }

  return (
    <AnimatedContent
      distance={40}
      duration={0.55}
      delay={cardIndex * 0.1}
      className="facet-animated-card"
    >
      {children}
    </AnimatedContent>
  );
};
